import { render, staticRenderFns } from "./SSCustomerView.vue?vue&type=template&id=91089036&scoped=true&"
import script from "./SSCustomerView.vue?vue&type=script&lang=js&"
export * from "./SSCustomerView.vue?vue&type=script&lang=js&"
import style0 from "./SSCustomerView.vue?vue&type=style&index=0&id=91089036&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91089036",
  null
  
)

export default component.exports